import { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { useTranslation } from "react-i18next";
import InputMask from "react-input-mask";
import Select from "react-select";
import {
  Button,
  Card,
  CardBody,
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";

import swal from "sweetalert";
import {
  convertToDateString,
  DateOfBirthValidater,
  isUrdu,
  LoadingSpinner,
} from "../../constants/const";
import { ApiResponsibility } from "../config/responsibilityType/ApiResponsibilityType";
import { GetLanguageString } from "../helper/Components";
import { addMember } from "../member/ApiMember";
import useForm from "../shared/useForm";
const AddNonRafiqUserModal = ({ setModal, onSaved }) => {
  const toggle = () => {
    setModal(false);
  };
  const { t } = useTranslation();
  const initialValues = {
    fullName: "",
    fatherName: "",
    cnic: "",
    phone: "",
    address: "",
    referenceNote: "",
    responsibilityId: 0,
    responsibilityLabel: "",
    responsibilityDate: null,
    displayName: "",
  };

  const [selectedDateOfBirth, setSelectedDateOfBirth] = useState(null);
  const [loading, setLoading] = useState(false);
  const [responsibilityOptions, setResponsibilityOptions] = useState([]);
  const { errors, setErrors, values, setValues, handleInputChange } =
    useForm(initialValues);
  const getTextClassName = (value, baseClassName = "") =>
    [baseClassName, isUrdu(value) ? "ur" : ""].filter(Boolean).join(" ");

  useEffect(() => {
      ApiResponsibility()
        .GetNonRafiqReponsibilities()
        .then((res) => {
          setResponsibilityOptions(res.data);
        })
        .catch((err) => console.log(err));
  }, []);

  const validate = () => {
    let temp = {};

    temp.fullName =
      values.fullName !== "" ? (
        ""
      ) : (
        <GetLanguageString props="member_first_name_error_message" />
      );
    temp.fatherName =
      values.fatherName !== "" ? (
        ""
      ) : (
        <GetLanguageString props="member_father_name_error_message" />
      );
    temp.cnic =
      values.cnic !== "" ? (
        values.cnic.replace(/-/g, "").length === 13 ? (
          ""
        ) : (
          "CNIC is not valid. It must be 13 numbers."
        )
      ) : (
        <GetLanguageString props="member_cnic_error_message" />
      );
    temp.birthDate =
      selectedDateOfBirth !== null ? (
        DateOfBirthValidater(selectedDateOfBirth) ? (
          ""
        ) : (
          <GetLanguageString props="member_birth_date_less_error_message" />
        )
      ) : (
        <GetLanguageString props="member_birth_date_error_message" />
      );
    const selectedResponsibility = responsibilityOptions.find(
      (opt) => opt.value === values.responsibilityId,
    );
    if (selectedResponsibility?.isMultiple) {
      temp.displayName =
        values.displayName !== "" ? (
          ""
        ) : (
          <GetLanguageString props="responsibility_title_err" />
        );
    }

    setErrors({
      ...temp,
    });

    return Object.values(temp).every((x) => x === "");
  };

  const handleResponsibilityChange = (record) => {
    if (record !== null) {
      setValues({
        ...values,
        responsibilityId: record.value,
        responsibilityLabel: record.label,
        displayName: record.isMultiple ? values.displayName : "",
      });
    } else {
      setValues({
        ...values,
        responsibilityId: 0,
        responsibilityLabel: "",
        displayName: "",
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;

    setLoading(true);
    const payload = {
      responsibilityDisplayName: showDisplayName ? values.displayName : "",
      responsibilityDate: values.responsibilityDate
        ? convertToDateString(values.responsibilityDate)
        : null,
      responsibilityId: values.responsibilityId,
      referenceNote: values.referenceNote,
      currentAddress: values.address,
      mobileNumber: values.phone,
      fatherName: values.fatherName,
      fullName: values.fullName,
      cnic: values.cnic ? values.cnic.replace(/-/g, "") : "",
      birthDate: convertToDateString(selectedDateOfBirth),
      joiningDate: convertToDateString(new Date()),
      isRafiq: false
    };

    addMember()
      .AddNonRafiqUser(payload)
      .then((res) => {
        setLoading(false);
        swal({
          title: t("user_added_success_message"),
          icon: "success",
          buttons: "OK",
        });
        if (onSaved) onSaved();
        toggle();
      })
      .catch((err) => {
        setLoading(false);
        swal({
          title: err.response?.data || err.message || "Error",
          icon: "error",
          buttons: "OK",
        });
        console.log(err);
      });
  };

  const selectedResponsibility = responsibilityOptions.find(
    (opt) => opt.value === values.responsibilityId,
  );
  const showDisplayName = selectedResponsibility?.isMultiple;

  return (
    <Modal size="xl" isOpen={true} className="inmodal" autoFocus={false}>
      <ModalHeader className="modal-title" tag="h4">
        {<GetLanguageString props="member_add_non_rafiq_user" />}
      </ModalHeader>
      <ModalBody className="py-3">
        {loading ? (
          LoadingSpinner()
        ) : (
          <div className="d-flex flex-column">
            <Card className="mb-2 border shadow-none">
              <CardBody className="p-3">
                <h5 className="mb-2 pb-2 border-bottom font-weight-bold">
                  {<GetLanguageString props="user_details" />}
                </h5>
                <Row className="g-2">
                  <Col md="6">
                    <FormGroup className="mb-2">
                      <Label className="col-form-label">
                        {<GetLanguageString props="member_first_name" />}
                      </Label>
                      <Input
                        className={getTextClassName(values.fullName)}
                        type="text"
                        name="fullName"
                        value={values.fullName}
                        onChange={handleInputChange}
                      />
                      {errors.fullName && (
                        <h4 className="text-error">{errors.fullName}</h4>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup className="mb-2">
                      <Label className="col-form-label">
                        {<GetLanguageString props="member_father_name" />}
                      </Label>
                      <Input
                        className={getTextClassName(values.fatherName)}
                        type="text"
                        name="fatherName"
                        value={values.fatherName}
                        onChange={handleInputChange}
                      />
                      {errors.fatherName && (
                        <h4 className="text-error">{errors.fatherName}</h4>
                      )}
                    </FormGroup>
                  </Col>
                </Row>
                <Row className="g-2">
                  <Col md="6">
                    <FormGroup className="mb-2">
                      <Label className="col-form-label">
                        {<GetLanguageString props="member_cnic" />}
                      </Label>
                      <InputMask
                        mask="99999-9999999-9"
                        value={values.cnic}
                        onChange={handleInputChange}
                        name="cnic"
                        maskChar=""
                      >
                        {(inputProps) => (
                          <Input
                            {...inputProps}
                            type="text"
                            className="no-drag"
                            placeholder="______-_______-_"
                          />
                        )}
                      </InputMask>
                      {errors.cnic && (
                        <h4 className="text-error">{errors.cnic}</h4>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup className="mb-2">
                      <Label className="col-form-label">
                        {<GetLanguageString props="member_date_of_birth" />}
                      </Label>
                      <DatePicker
                        showYearDropdown
                        dropdownMode="select"
                        placeholderText="dd/mm/yyyy"
                        className="form-control"
                        selected={selectedDateOfBirth}
                        maxDate={new Date()}
                        onChange={(value) => setSelectedDateOfBirth(value)}
                        dateFormat="dd/MM/yyyy"
                      />
                      {errors.birthDate && (
                        <h4 className="text-error">{errors.birthDate}</h4>
                      )}
                    </FormGroup>
                  </Col>
                </Row>
                <Row className="g-2">
                  <Col md="6">
                    <FormGroup className="mb-2">
                      <Label className="col-form-label">
                        {<GetLanguageString props="member_phone" />}
                      </Label>
                      <Input
                        className={getTextClassName(values.phone)}
                        type="text"
                        name="phone"
                        value={values.phone}
                        onChange={handleInputChange}
                      />
                      {errors.phone && (
                        <h4 className="text-error">{errors.phone}</h4>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup className="mb-2">
                      <Label className="col-form-label">
                        {<GetLanguageString props="member_address" />}
                      </Label>
                      <Input
                        className={getTextClassName(values.address)}
                        type="text"
                        name="address"
                        value={values.address}
                        onChange={handleInputChange}
                      />
                      {errors.address && (
                        <h4 className="text-error">{errors.address}</h4>
                      )}
                    </FormGroup>
                  </Col>
                </Row>
                <Row className="g-2">
                  <Col md="12">
                    <FormGroup className="mb-0">
                      <Label className="col-form-label">
                        {<GetLanguageString props="member_reference_note" />}
                      </Label>
                      <Input
                        className={getTextClassName(values.referenceNote)}
                        type="text"
                        name="referenceNote"
                        value={values.referenceNote}
                        onChange={handleInputChange}
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </CardBody>
            </Card>
            <Card className="mb-0 border shadow-none">
              <CardBody className="p-3">
                <h5 className="mb-2 pb-2 border-bottom font-weight-bold">
                  {<GetLanguageString props="member_responsibility" />}
                </h5>
                <Row className="g-2">
                  <Col md={showDisplayName ? "4" : "6"}>
                    <FormGroup className="mb-0">
                      <Label className="col-form-label">
                        {(
                          <GetLanguageString props="member_select_responsibilities" />
                        ) || "Responsibility"}
                      </Label>
                      <Select
                        options={responsibilityOptions}
                        value={
                          responsibilityOptions.find(
                            (opt) => opt.value === values.responsibilityId,
                          ) || null
                        }
                        className="basic-single ur"
                        classNamePrefix="select"
                        placeholder={"Select"}
                        isClearable={true}
                        onChange={handleResponsibilityChange}
                      />
                    </FormGroup>
                  </Col>
                  {showDisplayName && (
                    <Col md="4">
                      <FormGroup className="mb-0">
                        <Label className="col-form-label">
                          {<GetLanguageString props="responsibility_title" />}
                        </Label>
                        <Input
                          className={getTextClassName(
                            values.displayName,
                            "no-drag",
                          )}
                          type="text"
                          name="displayName"
                          value={values.displayName}
                          onChange={handleInputChange}
                          {...(errors?.displayName && { invalid: true })}
                        />
                        {errors.displayName && (
                          <h4 className="text-error">{errors.displayName}</h4>
                        )}
                      </FormGroup>
                    </Col>
                  )}
                  <Col md={showDisplayName ? "4" : "6"}>
                    <FormGroup className="mb-0">
                      <Label className="col-form-label">
                        {
                          <GetLanguageString props="member_member_detail_common_responsibility_date" />
                        }
                      </Label>
                      <DatePicker
                        showYearDropdown
                        dropdownMode="select"
                        placeholderText="dd/mm/yyyy"
                        className="form-control"
                        dateFormat="dd/MM/yyyy"
                        selected={values.responsibilityDate}
                        maxDate={new Date()}
                        onChange={(value) =>
                          setValues({ ...values, responsibilityDate: value })
                        }
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="white" onClick={toggle}>
          {<GetLanguageString props="common_cancel" />}
        </Button>
        <Button color="primary" onClick={handleSubmit} disabled={loading}>
          {<GetLanguageString props="common_save_changes" />}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AddNonRafiqUserModal;
